'use client';
import { jsxs, jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';

const FlagGbAsset = ({ width, height, ...props }, ref) => /* @__PURE__ */ jsxs(
  "svg",
  {
    viewBox: "0 0 28 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    width,
    height,
    ref,
    "aria-hidden": true,
    ...props,
    children: [
      /* @__PURE__ */ jsx("rect", { width: 28, height: 20, fill: "#001C5B" }),
      /* @__PURE__ */ jsx("path", { d: "M25.9 20L0 3.25V0H2.1L28 16.5V20H25.9Z", fill: "white" }),
      /* @__PURE__ */ jsx("path", { d: "M2.1 20L28 3.25V0H25.9L0 16.5V20H2.1Z", fill: "white" }),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M6.63158 7.00006L0 2.56528V1.00006L9 7.00006H6.63158Z",
          fill: "#CA0028"
        }
      ),
      /* @__PURE__ */ jsx("path", { d: "M21.3684 13L28 17.4348V19L19 13H21.3684Z", fill: "#CA0028" }),
      /* @__PURE__ */ jsx("path", { d: "M19.3404 7L28 1.03704V0H27.0638L17 7H19.3404Z", fill: "#CA0028" }),
      /* @__PURE__ */ jsx("path", { d: "M8.65958 13L0 18.963V20H0.936168L11 13H8.65958Z", fill: "#CA0028" }),
      /* @__PURE__ */ jsx("rect", { x: 11, width: 6, height: 20, fill: "white" }),
      /* @__PURE__ */ jsx(
        "rect",
        {
          y: 13,
          width: 6,
          height: 28,
          transform: "rotate(-90 0 13)",
          fill: "white"
        }
      ),
      /* @__PURE__ */ jsx("rect", { x: 12, width: 4, height: 20, fill: "#CA0028" }),
      /* @__PURE__ */ jsx(
        "rect",
        {
          y: 12,
          width: 4,
          height: 28,
          transform: "rotate(-90 0 12)",
          fill: "#CA0028"
        }
      )
    ]
  }
);
const VpFlagGbAsset = forwardRef(FlagGbAsset);

export { VpFlagGbAsset as default };
